module.exports = __webpack_public_path__ + "static/media/french-classes-in-delhi.34607b80.jpeg";